import './utils/storageInit';
import { initializeApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { 
  initializeFirestore, 
  persistentLocalCache, 
  persistentMultipleTabManager, 
  persistentSingleTabManager,
  connectFirestoreEmulator 
} from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";

// Die Firebase-Konfiguration für das Projekt "planning-with-ai-cf630"
const firebaseConfig = {
  apiKey: "AIzaSyBASLhnLlt9gUrXaAu5kuJh_PG3s8TQQ74",
  authDomain: "planning-with-ai-cf630.firebaseapp.com",
  projectId: "planning-with-ai-cf630",
  storageBucket: "planning-with-ai-cf630.firebasestorage.app",
  messagingSenderId: "1078201240419",
  appId: "1:1078201240419:web:afcd955ad31ced968be156"
};

const app = initializeApp(firebaseConfig);
export const functions = getFunctions(app, "europe-west1");

// Persistent local cache in IndexedDB with force ownership:
// Stores all cache purely in IndexedDB, avoiding 5MB localStorage target/mutation bloat
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentSingleTabManager({ forceOwnership: true })
  })
});
export const storage = getStorage(app);
export const auth = getAuth(app);

// Lokale Test-/Entwicklungsumgebung: Firebase Emulator nutzen, falls explizit aktiviert
// (entweder via Env-Variable VITE_USE_FIREBASE_EMULATOR=true oder localStorage GWANTT_USE_EMULATOR=true)
const useFirebaseEmulator =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") &&
  ((import.meta as any).env?.VITE_USE_FIREBASE_EMULATOR === "true" ||
    window.localStorage?.getItem("GWANTT_USE_EMULATOR") === "true");

if (useFirebaseEmulator) {
  console.info("[Firebase] Verbinde mit lokalen Firebase Emulatoren (Auth:9099, Firestore:8080, Functions:5001, Storage:9199)...");
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}
